module.exports = __webpack_public_path__ + "img/discord.eab8494d.svg";